import Module from "@/modules/query-history/Module";
import QueryHistory from "@/modules/query-history/views/QueryHistory";

export default {
    path: "/query-history",
    component: Module,
    children: [
        {
            path: "",
            component: QueryHistory,
            meta: {
                title: "История поиска"
            }
        }
    ]
};
